module.exports = __webpack_public_path__ + "static/qr.wx-4d07180bca1c164c46d65de3da822672.jpeg";